import React from 'react';
import styled from 'styled-components';

import AndroidIcon from '../assets/svg/android.svg';
import AppleIcon from '../assets/svg/apple.svg';

const SoIconContainer = styled.img`
  width: ${({ theme: { units } }) => units.sizes.ELEMENT_SMALL};
  margin: 0 auto;
`;

interface SoIconProps {
  so: 'android' | 'ios',
}

function SoIcon({
  so
}: SoIconProps) {
  return (
    <SoIconContainer src={so === 'android' ? AndroidIcon : AppleIcon} />
  );
}

export default SoIcon;

SoIcon.defaultProps = {
  so: 'android',
}
